import React, { useCallback, useEffect, useState } from "react";

const AuthContext = React.createContext({
  isLoggedIn: false,
  token: null,
  onLogin: () => {},
  onLogout: () => {},
});

const calculateRemainingTime = (exp) => {
  const currentTime = new Date().getTime();
  const adjExpTime = new Date(exp).getTime();
  const remainingDuration = adjExpTime - currentTime;
  return remainingDuration;
};

const retriveStoredToken = () => {
  const storedToken = localStorage.getItem("token");
  const storedExpDate = localStorage.getItem("expDate");
  const remainingTime = calculateRemainingTime(storedExpDate);
  if (remainingTime <= 60000) {
    localStorage.removeItem("token");
    localStorage.removeItem("expDate");
    return null;
  }
  return {
    token: storedToken,
    duration: remainingTime,
  };
};

let logoutTimer;

export const AuthContextProvider = ({ children }) => {
  const tokenData = retriveStoredToken();

  let initialToken;
  if (tokenData) {
    initialToken = tokenData.token;
  }
  const [token, setToken] = useState(initialToken);

  const logoutHandler = useCallback(() => {
    setToken(null);
    localStorage.removeItem("token");
    localStorage.removeItem("expDate");

    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }
  }, []);

  const loginHandler = useCallback(
    (token, exp) => {
      setToken(token);
      localStorage.setItem("token", token);
      localStorage.setItem("expDate", exp);
      const remainingTime = calculateRemainingTime(exp);

      logoutTimer = setTimeout(logoutHandler, remainingTime);
    },
    [logoutHandler]
  );

  useEffect(() => {
    if (tokenData) {
      logoutTimer = setTimeout(logoutHandler, tokenData.duration);
    }

    return () => clearTimeout(logoutTimer);
  }, [logoutHandler, tokenData]);

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: !!token,
        token: token,
        onLogin: loginHandler,
        onLogout: logoutHandler,
      }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
